import React, { useEffect, useState } from 'react';
import { Col, Dropdown, Image, Row } from 'react-bootstrap';
import { Controller, useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';



import i18n from 'I18n';



import BaseMultipleSelectorDropDown from 'components/base/BaseMultipleSelectorDropDown';
import BaseMultipleSelectorV2 from 'components/base/BaseMultipleSelectorV2';
import BaseTabContainer from 'components/base/BaseTabContainer';
import { SectionTopTitle } from 'components/base/CommonComponent';
import { CustomDropGroup } from 'components/base/CustomDropGroup';
import { ImageButton } from 'components/base/CustomImageButton';
import { ReactHookFormMarkDown } from 'components/base/CustomMarkDownArea';
import CustomRadios from 'components/base/CustomRadios';
import CustomTips from 'components/base/CustomTips';
import { ReactHookFormErrorMessage, hasError } from 'components/base/ErrorFieldMessage';
import InputFieldControl from 'components/base/InputFieldControl';
import BasePrompt from 'components/base/prompt/BasePrompt';
import BrandSelectDropdown from 'components/campaign/campaignCreation/BrandSelectDropdown';
import { CustomTitleWithDropDown } from 'components/customer/CustomTitleWithDropDown';
import { CustomTitleLabel } from 'components/earning/CustomBaseComponments';
import ReactHookFormSwitch from 'components/reactHookFormComponents/ReactHookFormSwitch';
import ReactHookFormTitleWithRadio from 'components/reactHookFormComponents/ReactHookFormTitleWithRadio';
import { COUPON_MODES, COUPON_REDEMPTION_METHOD, COUPON_SET_MEDIUM, COUPON_SET_TYPES, COUPON_STORE_GROUP_BY_TYPE, COUPON_TYPES, CustomerSelectionBehavior, LanguageConfig, STORE_LOADING_TYPE } from 'config/CustomEnums';
import { PermissionCodes } from 'config/PermissionCodes';
import { ProcessEnvConfig } from 'config/ProcessEnvConfig';



import { createAction } from 'utils';
import { capitalizeFirstLetter } from 'utils/StringUtil';



import CloseIcon from 'assets/images/close.svg';
import DeleteIcon from 'assets/images/deleteIcon.png';



import './CouponGeneral.scss';


const CREATE_NEW_TYPE = {
  brand: 'brand',
  store: 'store',
  none: 'none',
};

const StoreGroupBy = [
  ...(ProcessEnvConfig.haveShopMall
    ? [
        {
          label: 'Mall',
          type: 'mall',
          displayTitle: 'Store grouped by mall',
          value: COUPON_STORE_GROUP_BY_TYPE.MALL,
          namespace: 'mall',
          key: 'filterStoreMall',
        },
      ]
    : []),
  {
    label: 'Store category',
    type: 'storeCategory',
    displayTitle: 'Store grouped by store category',
    value: COUPON_STORE_GROUP_BY_TYPE.STORE_CATEGORY,
    namespace: 'storeCategoryList',
    key: 'filterStoreCategory',
  },
  {
    label: 'Brand',
    type: 'brand',
    displayTitle: 'Store grouped by brand',
    value: COUPON_STORE_GROUP_BY_TYPE.BRAND,
    namespace: 'brand',
    key: 'filterStoreBrand',
  },
];

const mapPropsToState = (state) => ({
  brandList: state.brand.brandList,
  allBrandList: state.brand.allBrandList,
  storeCategoryList: state.storeCategoryList.categoryList || [],
  mallList: state.mall.pagedMallList,
  couponStores: state.storeModel.couponStores || {},
});

const CouponSpecialStore = ({
  language,
  onFocus = () => {},
  brandList = [],
  allBrandList = [],
  storeCategoryList = [],
  mallList = [],
  couponStores = {},
}) => {
  const [refreshDate, setRefreshDate] = useState(new Date());
  const [createNewType, setCreateNewType] = useState(CREATE_NEW_TYPE.none);
  const [canSelectStoreGroupBy, setCanSelectStoreGroupBy] =
    useState(StoreGroupBy);
  const [selectStoreGroupBy, setSelectStoreGroupBy] = useState([]);

  const [needRefreshStore, setNeedRefreshStore] = useState(false);
  // const [selectedMall, setSelectedMall] = useState([]);
  // const [selectedStoreCategory, setSelectedStoreCategory] = useState([]);
  // const [selectedBrand, setSelectedBrand] = useState([]);
  const dispatch = useDispatch();
  const params = useParams();
  const { id } = params;
  const createNewText =
    createNewType === CREATE_NEW_TYPE.brand ? 'brand' : 'store';
  const { watch, setValue, control, formState, clearErrors } = useFormContext();
  const { errors } = formState;

  const typeField = 'type';
  const watchType = watch(typeField);
  const watchMediumType = watch('mediumType');

  const watchFilterStoreBy = watch('filterStoreBy') || {};
  const watchDisplayOnFrontendBrands = watch('displayOnFrontendBrands') || [];
  const removedStoreConditions = watch('removedStoreConditions') || {};

  useEffect(() => {
    if (id && watchType === COUPON_TYPES.NORMAL) {
      dispatch(
        createAction('storeModel/getAllCouponStores')({
          couponTemplateId: id,
        }),
      );
    } else {
      // let defaultFilters = [];
      let selectedFilters = [];

      Object.keys(watchFilterStoreBy).map((filter) => {
        selectedFilters.push({
          ...(StoreGroupBy.filter((group) => group.type === filter)?.[0] || {}),
          list:
            filter === 'brand'
              ? allBrandList
              : filter === 'storeCategory'
              ? storeCategoryList
              : mallList,
          // targetList: watchFilterStoreBrand,
        });
      });

      setCanSelectStoreGroupBy(
        StoreGroupBy.filter(
          (group) => !Object.keys(watchFilterStoreBy).includes(group.type),
        ),
      );
      setSelectStoreGroupBy(selectedFilters);
    }
  }, [id]);

  useEffect(() => {
    setNeedRefreshStore(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchFilterStoreBy]);

  return (
    <>
      {id || language !== LanguageConfig.english ? (
        <SectionTopTitle title={'Select applicable store'} />
      ) : (
        <>
          <div className="store-filter-area-title create-coupon-with-stores">
            <SectionTopTitle title={'Select applicable store'} />
            <button
              type="button"
              className="btn-link reset-button"
              onClick={() => {
                setCanSelectStoreGroupBy(StoreGroupBy);
                setSelectStoreGroupBy([]);

                setValue(
                  'filterStoreBy',
                  {},
                  {
                    shouldDirty: true,
                  },
                );

                dispatch({
                  type: 'storeModel/updateState',
                  payload: {
                    couponStores: {},
                  },
                });
              }}
            >
              Reset
            </button>
          </div>

          <CustomTitleLabel title="Select applicable store" />
          <label className="tips-message">
            Use the condition filters (mall, store category, brand) to choose
            your preferred stores. After making your selection, you can easily
            remove any unnecessary stores in the "Summary of Selected Stores"
            section below.
          </label>
          <div className="store-filter-area">
            {selectStoreGroupBy.map((groupBy, index) => (
              <div>
                <Controller
                  control={control}
                  name={'filterStoreBy'}
                  render={({ field: value }) => {
                    // console.log('@@242-277: ', value, groupBy.targetList)
                    return (
                      <>
                        <BaseMultipleSelectorV2
                          title={`Filter by ${groupBy.label.toLowerCase()}`}
                          size={['shorter']}
                          onFocusFunc={() => {
                            // onFocus('selectedStores');
                          }}
                          namespace={groupBy.namespace}
                          data={{
                            sourceData: groupBy.list,
                            targetData:
                              watchFilterStoreBy[groupBy.type] || [],
                            targetChange: (v) => {
                              setValue(
                                'filterStoreBy',
                                {
                                  ...(watchFilterStoreBy || {}),
                                  [groupBy.type]: v,
                                },
                                {
                                  shouldDirty: true,
                                },
                              );
                            },
                          }}
                          // error={{
                          //   error: hasError(errors, 'selectedStores'),
                          // }}
                        />
                        {/* <ReactHookFormErrorMessage errors={errors} id="selectedStores" /> */}
                      </>
                    );
                  }}
                />
                <button
                  className="reset-button content-delete-button-area"
                  type="button"
                  onClick={() => {
                    setCanSelectStoreGroupBy([
                      ...(canSelectStoreGroupBy || []),
                      groupBy,
                    ]);
                    setSelectStoreGroupBy(
                      selectStoreGroupBy.filter(
                        (g) => g.value !== groupBy.value,
                      ),
                    );

                    const newFilter = {...(watchFilterStoreBy || {})}
                    delete newFilter[groupBy.type]
                    setValue(
                      'filterStoreBy',
                      newFilter,
                      {
                        shouldDirty: true,
                      },
                    );
                  }}
                >
                  <Image src={DeleteIcon} className="content-delete-button" />
                </button>
              </div>
            ))}
            {canSelectStoreGroupBy.length > 0 ? (
              <Dropdown>
                <Dropdown.Toggle
                  className="btn-back-button-common content-add-button"
                  variant="none"
                  id={`dropdown-condition`}
                >
                  + Add AND Condition to Select Store
                </Dropdown.Toggle>

                <Dropdown.Menu style={{ zIndex: 2 }}>
                  {canSelectStoreGroupBy.map((groupBy) => (
                    <Dropdown.Item
                      onClick={() => {
                        setCanSelectStoreGroupBy(
                          canSelectStoreGroupBy.filter(
                            (val) => val.value !== groupBy.value,
                          ),
                        );
                        const selectedNewGroupBy = { ...groupBy };
                        if (
                          groupBy.value === COUPON_STORE_GROUP_BY_TYPE.MALL
                        ) {
                          selectedNewGroupBy.list = mallList;
                          selectedNewGroupBy.namespace = 'mall';
                          selectedNewGroupBy.key = 'filterStoreMall';
                        } else if (
                          groupBy.value ===
                          COUPON_STORE_GROUP_BY_TYPE.STORE_CATEGORY
                        ) {
                          selectedNewGroupBy.list = storeCategoryList;
                          selectedNewGroupBy.namespace = 'storeCategoryList';
                          selectedNewGroupBy.key = 'filterStoreCategory';
                        } else {
                          selectedNewGroupBy.list = allBrandList;
                          selectedNewGroupBy.namespace = 'brand';
                          selectedNewGroupBy.key = 'filterStoreBrand';
                        }
                        setSelectStoreGroupBy([
                          ...selectStoreGroupBy,
                          selectedNewGroupBy,
                        ]);
                      }}
                    >
                      <div className="display-flex-area">
                        <label className="li-label">{groupBy.label}</label>
                      </div>
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            ) : null}
          </div>

        </>
      )}

      <div className="store-filter-area-title">
        <SectionTopTitle
          title={`Summary of selected store (${
            couponStores?.stores?.length || 0
          })`}
        />
        {id || language !== LanguageConfig.english ? null : (
          <>
            <button
              type="button"
              className="btn-link reset-button"
              onClick={() => {
                dispatch(
                  createAction('storeModel/getAllCouponStores')({
                    brandIds: watchFilterStoreBy?.brand?.map((b) => b.pk),
                    mallIds: watchFilterStoreBy?.mall?.map((b) => b.pk),
                    storeCategoryIds: watchFilterStoreBy?.storeCategory?.map(
                      (b) => b.pk,
                    ),
                    storeType: watchMediumType,
                  }),
                );
                // setValue(
                //   'removedStoreConditions',
                //   {},
                //   {
                //     shouldDirty: true,
                //   },
                // );
                setNeedRefreshStore(false);
              }}
            >
              Confirm or Refresh
              <CustomTips
                detail={
                  'After changed the above condition filters, please click "Confirm" or "Refresh" to update this list.'
                }
              />
            </button>
          </>
        )}
      </div>
      <div
        className={`selected-store-filter-area store-result ${
          !!id || language != LanguageConfig.english ? 'disabled' : ''
        }`}
      >
        <BaseTabContainer
          tabs={StoreGroupBy.map((groupBy) => ({
            name: groupBy.displayTitle,
            content: (
              <CustomDropGroup
                type={groupBy.type}
                data={
                  couponStores?.[
                    `groupBy${capitalizeFirstLetter(groupBy.type)}`
                  ]
                }
                action={(condition) => {
                  // setValue(
                  //   'removedStoreConditions',
                  //   {
                  //     ...(removedStoreConditions || {}),
                  //     [condition.type]: [
                  //       ...(removedStoreConditions[condition.type] || []),
                  //       condition.obj.id,
                  //     ],
                  //   },
                  //   {
                  //     shouldDirty: true,
                  //   },
                  // );
                  dispatch({
                    type: 'storeModel/updateCouponStores',
                    payload: {
                      removedStoreConditions: {
                        ...condition,
                        value: condition.obj.id,
                      },
                    },
                  });
                }}
                disabled={!!id || language != LanguageConfig.english}
              />
            ),
          }))}
          tabNavClassName="global-setting-nav"
        />
      </div>
      <ReactHookFormErrorMessage errors={errors} id="selectedStores" />

      <CustomTitleLabel
        title={'Select brand to be displayed on front end (optional)'}
      />
      <label className="tips-message">
        The front end currently displays only one brand at a time. No brand will
        be shown if none or multiple brands are selected.
      </label>
      {language === LanguageConfig.english ? (
        <CustomTitleWithDropDown
          customClass={'filter-title'}
          title={''}
          source={brandList}
          placeholder={'Search by brand ID, name'}
          labelContainPk
          defaultValue={watchDisplayOnFrontendBrands || []}
          setValue={(value) => {
            setValue('displayOnFrontendBrands', value, { shouldDirty: true });
          }}
          loadMoreAction={'brand/getCurrentPageBrands'}
          filterAction={'brand/getCurrentPageBrands'}
          // customFilter={customFilter}
          defaultFilter={{
            isSelectorLoad: true,
            moreSearch: {
              searchField: 'searchNameOrId',
            },
            // ...defaultFilter,
          }}
          multiple={true}
          toolTips={true}
          notShowLabel={true}
          disableAutoFocus={true}
          customItem={(item) => `[ID: ${item?.pk}] ${item?.name}`}
        />
      ) : null}
      <div class="one-group display-brand-group">
        <ul>
          {watchDisplayOnFrontendBrands?.map((item) => (
            <li>
              <div class="dot"></div>
              [ID: {item?.value.pk}] {item?.value.name}
              <ImageButton
                image={CloseIcon}
                className={'close2'}
                action={() => {
                  setValue(
                    'displayOnFrontendBrands',
                    watchDisplayOnFrontendBrands.filter(
                      (v) => v.value.pk !== item.value.pk,
                    ),
                    { shouldDirty: true },
                  );
                }}
              />
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default connect(mapPropsToState)(CouponSpecialStore);